<div class="content">
  <img src="./assets/images/404 page error.png">
</div>